module.exports = __webpack_public_path__ + "img/header-engagementRingsHeart.b70b47e.jpg";